/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const SUBMIT_CONTACT_FORM_MUTATION = gql`
  mutation submitContactForm(
    $formType: String!,
    $formKey: String,
    $orderNumber: String,
    $fullName: String,
    $email: String,
    $phone: String,
    $store: String,
    $comment: String,
    $organizationName: String,
    $eventLocation: String,
    $eventDate: String,
    $eventType: String,
    $proposedLocation: String,
    $productName: String,
    $productCost: String,
    $subject: String,
    $giftcardNumber: String,
    $giftcardAmount: String,
    $recipientEmail: String,
    $rewardAccountEmail: String,
    $file: Upload,
    $topic: String,
    $option: String
  ) {
    submitContactForm(data: {
      formType: $formType,
      formKey: $formKey,
      orderNumber: $orderNumber,
      fullName: $fullName,
      email: $email,
      phone: $phone,
      store: $store,
      comment: $comment,
      organizationName: $organizationName,
      eventLocation: $eventLocation,
      eventDate: $eventDate,
      eventType: $eventType,
      proposedLocation: $proposedLocation,
      productName: $productName,
      productCost: $productCost,
      subject: $subject,
      giftcardNumber: $giftcardNumber,
      giftcardAmount: $giftcardAmount,
      recipientEmail: $recipientEmail,
      rewardAccountEmail: $rewardAccountEmail,
      file: $file,
      topic: $topic,
      option: $option
    })
  }
`;

export const SUBMIT_NEWSLETTER_FORM_MUTATION = gql`
  mutation submitNewsletterForm(
    $email: String!
  ) {
    submitNewsletterForm(email: $email)
  }
`;